/**
 * Reference https://github.com/yos1up/scratch2cpp/blob/main/web/crx/sb3_to_cpp.js (MIT LICENSE)
 * change by: 2024/09/20 Yoshinobu Obata (Yukai Engineering Inc.)
 *
 */
var CRC32 = require("crc-32");
class Sb2CppConverter {
    constructor(runtime){
        this.loopCounterIndex = 0;
        // タイマー割り込み内で参照される変数/リストの (生の) 名前
        this.timerSharedVars = new Set();
        this.timerSharedLists = new Set();
        // convertSnippet がタイマー割り込みハンドラ内の処理を生成中か
        this.inTimerHandler = false;
        this.existVariableNames = new Set();
        this.existListNames = new Set();
        this.blockIDs ={},
        this.variables = [];
        this.insideSerialAvailable = false;
        this.rotateMultipleFuncInit = false;
        this.servoWithTimeFuncInit = false;
        this.servoWithTime2FuncInit = false;
        this.servoWithTime3FuncInit = false;
        this.servoWithTime4FuncInit = false;
        this.accelInit = false;
        this.gyroInit = false;
        this.colorInit = false;
        this.ledInit = [];
        this.ultrasonicYukaiInit = false;
        this.ultrasonicYukaiAssignedPin = [];
        this.ultrasonicSeeedInit = false;
        this.ultrasonicSeeedAssignedPin = [];
        this.motorInit = false;
        this.rtcInit = false;
        this.rtcGotVal = false;
        this.speakerInit = false;
        this.speakerAssignedPin = [];
        this.buzzerAssignedPin = [];
        this.recorderInit = false;
        this.recorderAssignedPin = [];
        this.sevensegInit = false;
        this.sevensegAssignedPin = [];
        this.lcdInit = false;
        this.ledbarInit = false;
        this.ledbarAssignedPin = [];
        this.rgbledInit = false;
        this.rgbledAssignedPin = [];
        this.neopixcelInit = false;
        this.neopixcelAssignedPin = [];
        this.sendIRInit = false;
        this.checkReceivedIRInit = false;
        this.soundDirectionInit = false
        this.tempHumidInit = false;
        this.tempHumidAssignedPin = [];
        this.mp3playerInit = false;
        this.mp3playerAssignedPin = [];
        this.joystickInit = false;
        this.MP3PlayerType = null;
        this.writeFlag =true;
        this.proceduresCall = [];
        this.tinymlInit = false;
        // TinyML センサー固有の init コードを一度だけ出力するためのフラグ。
        // (this.tinymlInit は「モデルプレースホルダ」専用なので別管理)
        this.tinymlSensorInit = false;
        this.INPUT_PINS = {
            Port1: 'board.GROVE_CON1_SIG',
            Port2: 'board.GROVE_CON2_SIG',
            Port3: 'board.GROVE_CON3_SIG',
        }
        this.INOUT_PINS = {
            Port1: 'board.GROVE_CON1_SIG',
            Port2: 'board.GROVE_CON2_SIG',
        }
        this.OUTPUT_PINS = {
            Port1: 'board.GROVE_CON1_OPT',
            Port2: 'board.GROVE_CON2_OPT',
        }
        // LEDボタン用
        this.INPUT_LEDBUTTON_PINS = {
            Port1: 'board.GROVE_CON1_OPT',
            Port2: 'board.GROVE_CON2_OPT',
            Port3: 'board.GROVE_CON3_OPT',
        }

    }

    modifyVariableName(name) {
        if(!this.existVariableNames.has(name)){
            this.existVariableNames.add(name);
        }
        return 'var_' + Math.abs(CRC32.str(name)).toString(16);
    }

    modifyListName(name) {
        if(!this.existListNames.has(name)){
            this.existListNames.add(name);
        }
        return 'list_' + Math.abs(CRC32.str(name)).toString(16);
    }

    modifyFunctionName(name) {
        return 'func_' + Math.abs(CRC32.str(name)).toString(16);
    }

    modifyArgumentName(name) {
        return 'arg_' +  Math.abs(CRC32.str(name)).toString(16);
    }

    getProceduresCall(){
        this.proceduresCall = Array.from(new Set(this.proceduresCall)); //重複した呼び出しを削除
        return this.proceduresCall;
    }

    // タイマー割り込みSUBSTACK配下で参照される変数名/リスト名を再帰的に収集
    collectTimerSharedRefs(startId, blocks) {
        const visited = new Set();
        const vars = new Set();
        const lists = new Set();
        const walk = (id) => {
            if (!id || visited.has(id)) return;
            visited.add(id);
            const blk = blocks[id];
            if (!blk) return;
            if (blk['fields'] && blk['fields']['VARIABLE']) vars.add(blk['fields']['VARIABLE'][0]);
            if (blk['fields'] && blk['fields']['LIST']) lists.add(blk['fields']['LIST'][0]);
            if (blk['inputs']) {
                for (const key in blk['inputs']) {
                    const inp = blk['inputs'][key];
                    if (!Array.isArray(inp)) continue;
                    const second = inp[1];
                    if (typeof second === 'string') {
                        walk(second);
                    } else if (Array.isArray(second)) {
                        // shorthand: [12, name, id] = variable, [13, name, id] = list
                        if (second[0] === 12) vars.add(second[1]);
                        else if (second[0] === 13) lists.add(second[1]);
                    }
                }
            }
            if (blk['next']) walk(blk['next']);
        };
        walk(startId);
        return { vars, lists };
    }

    async getWriteFlag(){
        if(this.writeFlag && this.motorInit && this.speakerInit){
            this.writeFlag = await confirm("モータとスピーカをいっしょに使うとスピーカの音がきなたくなりますが、いいですか？");
        }
        return this.writeFlag;
    }
    initialErrorAlert(type){
        alert(`以下のセンサーの読み取るブロックが無いようです\n・${type}`)
        this.writeFlag = false
    }

    indent(codes, num) {
        /*
        Args:
            snippet <str> : every row in it has return code.
            num_space <int>: >= 0
        Returns:
            (str) indented snippet.
        */
        if (codes === '') return '';

        let codeList = codes.split('\n');
        if (codeList[codeList.length - 1] === '') codeList.pop();

        const spaces = ' '.repeat(num);

        return codeList.map(line => `${spaces}${line}\n`).join('');
      }

      processLiteral(obj) {
        /*
            obj <str/int/float>
            returns <str>
            if [obj] is interpretable as integer, return the integer stringified.
            else if [obj] is interpretable as numerical value, return the value stringified.
            if not interpretable, return the string double-quoted.
        */
        if (typeof obj == 'string') {
            // console.log(obj)
            if (!isNaN(obj) &&  isFinite(obj)) { // 標準的な記法かのチェック
                return obj;
            } else {
                // console.log('""をつけます')
                return '"' + obj + '"';
            }
        } else {
            return '' + obj;
        }
    }
    initConvert(id, allBlocksObject) {
        let src_include = '';
        let src_init = '';
        let src_setup = '';
        let next_src_include = '';
        let next_src_init = '';
        let next_src_setup = '';
        if (id) {
            const blockInfo = allBlocksObject[id];
            const opcode = blockInfo['opcode'];

            let funcName, text, pin, type, insideBlockID, conditionBlockID;
            let value, num;  // case 内の bare 代入で使う作業変数（strict mode 対策で明示宣言）

            switch (opcode) {
                case 'control_forever':
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'control_repeat':
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'control_wait_until':
                    conditionBlockID = allBlocksObject[id]['inputs']['CONDITION'][1] //条件内のブロックID
                    if (conditionBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(conditionBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'control_if':
                case 'control_repeat_until':
                    conditionBlockID = allBlocksObject[id]['inputs']['CONDITION'][1] //条件内のブロックID
                    if (conditionBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(conditionBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'control_if_else':
                    conditionBlockID = allBlocksObject[id]['inputs']['CONDITION'][1] //条件内のブロックID
                    if (conditionBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(conditionBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK2'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'procedures_call':
                    funcName = this.modifyFunctionName(blockInfo['mutation']['proccode'].split(' ')[0]);
                    this.proceduresCall.push(funcName);
                    break;

/*****************************************************************************************************/
/* Maker Board */
/*****************************************************************************************************/
                case 'makerBoard_motorforward':
                case 'makerBoard_motorbackward':
                    if (!this.motorInit) {
                        src_setup += `board.motorPWMBegin();\n`
                        this.motorInit = true;
                    }
                    break;

/*****************************************************************************************************/
/* Maker Board Digital */
/*****************************************************************************************************/
                case 'makerBoard_loopcode':
                    return [src_include, src_init, src_setup];
                case 'makerBoard_outerled':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    let ledUse = false;
                    // pinmodeがすでにoutになっているか確認
                    for (let i = 0; i < this.ledInit.length; i++) {
                        if(pin == this.ledInit[i]){
                            ledUse = true;
                        }
                    }
                    // pinmodeがoutになっていなかったら、設定
                    if(!ledUse){
                        src_setup += `pinMode(${pin}, OUTPUT);\n`
                        this.ledInit.push(pin)
                    }
                    break;

/*****************************************************************************************************/
/* Maker Board Analog */
/*****************************************************************************************************/

                case 'makerBoardAnalog_getaccel':
                    if (!this.accelInit) {
                        src_include += `#include <MMA7660.h>\n`
                        src_init += `MMA7660 accelemeter;\nfloat ax, ay, az;\n`
                        src_setup += `accelemeter.init();\n`
                        this.accelInit = true;
                    }
                    break;
                case 'makerBoardAnalog_getgyro':
                    if (!this.gyroInit) {
                        src_include += `#include <ITG3200.h>\n`
                        src_init += `ITG3200 gyro;\nfloat gx, gy, gz;\n`
                        src_setup += `gyro.init();\ngyro.zeroCalibrate(200,10);\n`
                        this.gyroInit = true;
                    }
                    break;
                case 'makerBoardAnalog_getcolor':
                    if (!this.colorInit) {
                        src_include += `#include "Adafruit_TCS34725.h"\n`
                        src_init += `Adafruit_TCS34725 tcs = Adafruit_TCS34725(TCS34725_INTEGRATIONTIME_50MS, TCS34725_GAIN_4X);\n`;
                        src_setup += `if (!tcs.begin()) {
errorStatus("eカラーセンサーと接続できません");\nwhile (1); // halt!\n}`;
                        this.colorInit = true;
                    }
                    break;
                case 'makerBoardAnalog_getultrasonicYukai':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.ultrasonicYukaiInit ) {
                        console.log('ultrasonic Yukai');
                        src_init += `uint16_t YukaiUltrasonicVal(MakerBoard::Ultrasonic pin){
    delay(50);
    return pin.Ranging();
}\n`
                        src_init += `MakerBoard::Ultrasonic ultrasonic${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});\n`
                        src_init += `float var_ultrasonic${pin};\n`
                        this.ultrasonicYukaiAssignedPin[0] = pin;
                        this.ultrasonicYukaiInit = true;
                    } else if (this.ultrasonicYukaiAssignedPin.indexOf(pin) == -1) {
                        src_init += `MakerBoard::Ultrasonic ultrasonic${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});\n`
                        src_init += `float var_ultrasonic${pin};\n`
                        this.ultrasonicYukaiAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAnalog_getultrasonic':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.ultrasonicSeeedInit ) {
                        console.log('ultrasonic Seeed');
                        src_include += `#include "Ultrasonic.h"\n`
                        src_init += `uint16_t ultrasonicVal(Ultrasonic pin){
    delay(50);
    return pin.MeasureInCentimeters();
}\n\n`

                        src_init += `Ultrasonic ultrasonic${pin}(${this.INOUT_PINS[pin]});\n`
                        src_init += `float var_ultrasonic${pin};\n`
                        this.ultrasonicSeeedAssignedPin[0] = pin;
                        this.ultrasonicSeeedInit = true;
                    } else if (this.ultrasonicSeeedAssignedPin.indexOf(pin) == -1) {
                        src_init += `Ultrasonic ultrasonic${pin}(${this.INOUT_PINS[pin]});\n`
                        src_init += `float var_ultrasonic${pin};\n`
                        this.ultrasonicSeeedAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAnalog_getTempHumid':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.tempHumidInit) {
                        src_include += `#include <DHT.h>\n`
                        src_init += `DHT dht(${this.INOUT_PINS[pin]}, DHT11);\nfloat lastHumidity = NAN;\nfloat lastTemperature = NAN;\nfloat humidity;\nfloat temperature;\n`
                        src_setup += `dht.begin();\n`
                        this.tempHumidInit = true;
                    }
                    break;
                case 'makerBoardAnalog_getSoundDirection':
                case 'makerBoardAnalog_soundDirection':
                    value = this.processValueInfo(blockInfo['inputs']['TH'], allBlocksObject);
                    if (!this.soundDirectionInit) {
                    src_init += `#define SDS_SLAVE_ADDRESS	0x30\n#define SDS_ACTVAL_REG		0x04\nfloat soundDegree = 0.0;\nfloat activity  = 0.0;\n
void getSoundDirection(){
byte valArry[8];
float degreeOrg;
bool  newValue;
int detect;

Wire.beginTransmission(SDS_SLAVE_ADDRESS);
Wire.write(0);
Wire.endTransmission(false);
Wire.requestFrom(SDS_SLAVE_ADDRESS, 8, true);

for(uint8_t index = 0; index < 8; index++ ) { valArry[index]=Wire.read(); }

newValue = valArry[6];
detect = ((int)valArry[0]*256+(int)valArry[1])/10;
activity 	= ((int)valArry[4]*256+(int)valArry[5])/10.0f;
if (detect != -1 && newValue==true){
    soundDegree		= ((int)valArry[0]*256+(int)valArry[1])/10.0f;
    degreeOrg	= ((int)valArry[2]*256+(int)valArry[3])/10.0f;

}
delay(50);
}\n`
                        src_setup += ` float ActivityValueThreshold = float(${value});
int 	actset;
byte writeValArry[4];
actset=(int)(ActivityValueThreshold*10);
writeValArry[0]=SDS_ACTVAL_REG;
writeValArry[1]=(actset>>8)&0xFF;
writeValArry[2]=(actset>>0)&0xFF;
Wire.begin();
Wire.beginTransmission(SDS_SLAVE_ADDRESS);
Wire.write(writeValArry,3);
Wire.endTransmission();\n`
                        this.soundDirectionInit = true;
                    }
                    break;
/*****************************************************************************************************/
/* Maker Board Advance */
/*****************************************************************************************************/
                case 'makerBoardAdvance_serialAvailable':
                    insideBlockID = allBlocksObject[id]['inputs']['SUBSTACK'][1] //ブロック内の先頭ブロックID
                    if (insideBlockID) {
                        [next_src_include, next_src_init, next_src_setup] = this.initConvert(insideBlockID, allBlocksObject);
                        src_include += next_src_include;
                        src_init += next_src_init;
                        src_setup += next_src_setup;
                    }
                    break;
                case 'makerBoardAdvance_timerLoop':
                    // トップレベルでのみ使用するブロックなので, 他ブロックのinit走査時はここで打ち切る
                    return [src_include, src_init, src_setup];
                case 'makerBoardAdvance_servowithtime':
                case 'makerBoardAdvance_servowithtime_two':
                case 'makerBoardAdvance_servowithtime_three':
                case 'makerBoardAdvance_servowithtime_four':
                    if (!this.rotateMultipleFuncInit){
                        src_init += `void _rotateMultiple(Servo* servos[], int starts[], int ends[], int count, float seconds) {
    int angles[4];
    int targetAngles[4];
    int directions[4];
    int totalSteps[4];
    float stepProgress[4];
    bool finished[4];
    
    int maxSteps = 0;
    for (int i = 0; i < count; i++) {
        angles[i] = starts[i];
        targetAngles[i] = ends[i];
        totalSteps[i] = abs(ends[i] - starts[i]);
        directions[i] = (ends[i] > starts[i]) ? 1 : -1;
        stepProgress[i] = 0.0;
        finished[i] = false;
        
        if (totalSteps[i] > maxSteps) {
            maxSteps = totalSteps[i];
        }
        
        servos[i]->write(starts[i]);
    }
    
    if (maxSteps == 0) return;
    
    int delayTime = (seconds * 1000.0 / maxSteps) - (0.1 / 60.0 * 1000.0);
    if (delayTime < 1) delayTime = 1;
    
    for (int step = 0; step < maxSteps; step++) {
        for (int i = 0; i < count; i++) {
            if (finished[i]) continue;
            
            float targetProgress = (float)(step + 1) * totalSteps[i] / maxSteps;
            
            if (targetProgress - stepProgress[i] >= 1.0) {
                angles[i] += directions[i];
                stepProgress[i] += 1.0;
                servos[i]->write(angles[i]);
                
                if (angles[i] == targetAngles[i]) {
                    finished[i] = true;
                }
            }
        }
        
        delay(delayTime);
    }
    
    for (int i = 0; i < count; i++) {
        servos[i]->write(targetAngles[i]);
    }
}\n`
                        this.rotateMultipleFuncInit = true;
                    }
                    if (opcode == 'makerBoardAdvance_servowithtime' && !this.servoWithTimeFuncInit) {
                        src_init += `void rotateWithTime(Servo& servo, float second, int start_angle, int end_angle) {
    Servo* servos[] = {&servo};
    int starts[] = {start_angle};
    int ends[] = {end_angle};
    _rotateMultiple(servos, starts, ends, 1, second);
}\n`
                        this.servoWithTimeFuncInit = true;
                        break;
                    }
                    else if (opcode == 'makerBoardAdvance_servowithtime_two' && !this.servoWithTime2FuncInit) {
                        src_init += `void rotateWithTime2(Servo& servo1, int start1, int end1, 
                     Servo& servo2, int start2, int end2, float second) {
    Servo* servos[] = {&servo1, &servo2};
    int starts[] = {start1, start2};
    int ends[] = {end1, end2};
    _rotateMultiple(servos, starts, ends, 2, second);
}\n`
                        this.servoWithTime2FuncInit = true;
                        break;
                    }
                    else if (opcode == 'makerBoardAdvance_servowithtime_three' && !this.servoWithTime3FuncInit) {
                        src_init += `void rotateWithTime3(Servo& servo1, int start1, int end1,
                     Servo& servo2, int start2, int end2,
                     Servo& servo3, int start3, int end3, float second) {
    Servo* servos[] = {&servo1, &servo2, &servo3};
    int starts[] = {start1, start2, start3};
    int ends[] = {end1, end2, end3};
    _rotateMultiple(servos, starts, ends, 3, second);
}\n`
                        this.servoWithTime3FuncInit = true;
                        break;
                    }
                    else if (opcode == 'makerBoardAdvance_servowithtime_four' && !this.servoWithTime4FuncInit) {
                        src_init += `void rotateWithTime4(Servo& servo1, int start1, int end1,
                     Servo& servo2, int start2, int end2,
                     Servo& servo3, int start3, int end3,
                     Servo& servo4, int start4, int end4, float second) {
    Servo* servos[] = {&servo1, &servo2, &servo3, &servo4};
    int starts[] = {start1, start2, start3, start4};
    int ends[] = {end1, end2, end3, end4};
    _rotateMultiple(servos, starts, ends, 4, second);
}\n`
                        this.servoWithTime4FuncInit = true;
                        break;
                    }
                    break;
                case 'makerBoardAdvance_setRTC_DS1307':
                case 'makerBoardAdvance_getRTC_DS1307':
                    if(!this.rtcInit){
                    src_init += `#include "DS1307.h"\nDS1307 clock;`;
                    src_setup += `clock.begin();`
                    this.rtcInit = true;
                    }
                    break;
                case 'makerBoardAdvance_speaker':
                    if (!this.speakerInit) {
                        src_init += `void sound(uint8_t pin, int hertz, float sec)
{
    long half_period = 1.0 / (float)hertz / 2.0 * 1000.0 * 1000.0;
    long play_time = hertz * sec;
    for(int i=0;i<play_time;i++)
    {
        digitalWrite(pin,HIGH);
        delayMicroseconds(half_period);
        digitalWrite(pin,LOW);
        delayMicroseconds(half_period);
    }
}
`
                        this.speakerInit = true; //モータとの競合判定用
                    }
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (this.speakerAssignedPin.indexOf(pin) == -1) {
                        src_setup += `pinMode(${this.INOUT_PINS[pin]}, OUTPUT);\n`;
                        this.speakerAssignedPin.push(pin);
                    }
                    break;
                case 'makerBoardAdvance_buzzer':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (this.buzzerAssignedPin.indexOf(pin) == -1) {
                        src_setup += `pinMode(${this.INOUT_PINS[pin]}, OUTPUT);\n`;
                        this.buzzerAssignedPin.push(pin);
                    }
                    break;
                case 'makerBoardAdvance_recorderREC':
                case 'makerBoardAdvance_recorderPlay':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.recorderInit) {
                        src_setup +=`pinMode(${this.INOUT_PINS[pin]}, OUTPUT);\n pinMode(${this.OUTPUT_PINS[pin]}, OUTPUT);\n digitalWrite(${this.INOUT_PINS[pin]}, HIGH);\n digitalWrite(${this.OUTPUT_PINS[pin]}, HIGH);\n`;
                        this.recorderInit = true;
                        this.recorderAssignedPin.push(pin);
                    }else if(this.recorderAssignedPin.indexOf(pin) == -1){
                        src_setup +=`pinMode(${this.INOUT_PINS[pin]}, OUTPUT);\n pinMode(${this.OUTPUT_PINS[pin]}, OUTPUT);\n digitalWrite(${this.INOUT_PINS[pin]}, HIGH);\n digitalWrite(${this.OUTPUT_PINS[pin]}, HIGH);\n`;
                        this.recorderAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_neopixel':
                case 'makerBoardAdvance_neopixelselect':
                case 'makerBoardAdvance_neopixelclear':
                    type = this.processValueInfo(blockInfo['inputs']['TYPE'], allBlocksObject);
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if(!this.neopixcelInit){
                        src_include += `#include <Adafruit_NeoPixel.h>\n`
                        if(type == "SEEED"){
                            src_init += `Adafruit_NeoPixel pixels${pin}(50, ${this.INOUT_PINS[pin]}, NEO_GRB + NEO_KHZ800);\n` //LEDの数は50までとする（不都合があれば変更）デジタルピンとして宣言
                        }else{
                            src_init += `Adafruit_NeoPixel pixels${pin}(50, ${this.OUTPUT_PINS[pin]}, NEO_GRB + NEO_KHZ800);\n` //LEDの数は50までとする（不都合があれば変更）デジタルピンとして宣言
                        }
                        src_setup += `pixels${pin}.begin();\n`
                        this.neopixcelInit = true;
                        this.neopixcelAssignedPin.push(pin);
                    }else if(this.neopixcelAssignedPin.indexOf(pin) == -1){
                        if(type == "SEEED"){
                            src_init += `Adafruit_NeoPixel pixels${pin}(50, ${this.INOUT_PINS[pin]}, NEO_GRB + NEO_KHZ800);\n` //LEDの数は50までとする（不都合があれば変更）デジタルピンとして宣言
                        }else{
                            src_init += `Adafruit_NeoPixel pixels${pin}(50, ${this.OUTPUT_PINS[pin]}, NEO_GRB + NEO_KHZ800);\n` //LEDの数は50までとする（不都合があれば変更）デジタルピンとして宣言
                        }
                        this.neopixcelAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_sevensegnum':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                    if (!this.sevensegInit) {
                        src_include += `#include <TM1637.h>\n`
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                        src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegInit = true;
                        this.sevensegAssignedPin.push(pin);
                    }else if(this.sevensegAssignedPin.indexOf(pin) == -1){
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                        src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegAssignedPin[1] = pin;
                    }
                    if (num.startsWith('var_')) {
                    }
                    else if(/"/.test(num)){
                        alert('デジタル表示: 数字入力では数字以外は使えません。');
                        this.writeFlag = false;
                    }
                    break;
                case 'makerBoardAdvance_sevensegstr':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                    if (!this.sevensegInit) {
                        src_include += `#include <TM1637.h>\n`
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                        src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegInit = true;
                        this.sevensegAssignedPin.push(pin);
                    }else if(this.sevensegAssignedPin.indexOf(pin) == -1){
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                        src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegAssignedPin[1] = pin;
                    }
                    if (text.startsWith('var_')) {
                        alert('デジタル表示: 文字入力では変数は使えません。');
                        this.writeFlag = false;
                    }
                    // textに数字以外が入ると""が勝手につくので…
                    else if(/"/.test(text)){
                        if(!/^[0-9A-Za-z_\^\-\* "]+$/.test(text)){
                            alert('デジタル表示: 入力した'+text+'には表示できない文字が入っています。');
                            this.writeFlag = false;
                        }
                    }
                    else{
                        if(!/^[0-9A-Za-z_\^\-\* ]+$/.test(text)){
                            alert('デジタル表示: 入力した"'+text+'"には表示できない文字が入っています。');
                            this.writeFlag = false;
                        }
                    }
                    break;
                case 'makerBoardAdvance_sevensegstrselect':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.sevensegInit) {
                        src_include += `#include <TM1637.h>\n`
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                            src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                            src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegInit = true;
                        this.sevensegAssignedPin.push(pin);
                    }else if(this.sevensegAssignedPin.indexOf(pin) == -1){
                        src_init += `TM1637 sevenseg${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]});`
                        src_setup +=`sevenseg${pin}.init();\nsevenseg${pin}.set(BRIGHT_TYPICAL);//BRIGHT_TYPICAL = 2,BRIGHT_DARKEST = 0,BRIGHTEST = 7\n`;
                        this.sevensegAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_lcdtext':
                case 'makerBoardAdvance_lcdchara':
                case 'makerBoardAdvance_lcdclear':
                    // text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                    if(!this.lcdInit){
                        src_include += `#include "rgb_lcd.h"\nrgb_lcd lcd;\n`
                        src_setup += `lcd.begin(16, 2);\n`
                        this.lcdInit = true;
                    }
                    break;
                case 'makerBoardAdvance_ledbar':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                    if (!this.ledbarInit) {
                        src_include += `#include <Grove_LED_Bar.h>\n`
                            src_init += `Grove_LED_Bar ledbar${pin}(${this.OUTPUT_PINS[pin]}, ${this.INOUT_PINS[pin]}, 0);\n`
                            src_setup += `ledbar${pin}.begin();\n`
                        this.ledbarInit = true;
                        this.ledbarAssignedPin.push(pin);
                    }else if(this.ledbarAssignedPin.indexOf(pin) == -1){
                            src_init += `Grove_LED_Bar ledbar${pin}(${this.OUTPUT_PINS[pin]}, ${this.INOUT_PINS[pin]}, 0);\n`
                            src_setup += `ledbar${pin}.begin();\n`
                        this.ledbarAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_ledbarbit':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                    if (!this.ledbarInit) {
                        src_include += `#include <Grove_LED_Bar.h>\n`
                        src_init += `Grove_LED_Bar ledbar${pin}(${this.OUTPUT_PINS[pin]}, ${this.INOUT_PINS[pin]}, 0);\n`
                        src_setup += `ledbar${pin}.begin();\n`
                        this.ledbarInit = true;
                        this.ledbarAssignedPin.push(pin);
                    }else if(this.ledbarAssignedPin.indexOf(pin) == -1){
                        src_init += `Grove_LED_Bar ledbar${pin}(${this.OUTPUT_PINS[pin]}, ${this.INOUT_PINS[pin]}, 0);\n`
                        src_setup += `ledbar${pin}.begin();\n`
                        this.ledbarAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_rgbled':
                case 'makerBoardAdvance_rgbledselect':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.rgbledInit) {
                        src_include += `#include <ChainableLED.h>\n`
                        src_init += `ChainableLED rgbled${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}, 10);\n`  // LEDの数は10までとする（不都合があれば変更）
                        src_setup += `rgbled${pin}.init();\n`
                        this.rgbledInit = true;
                        this.rgbledAssignedPin.push(pin);
                    }else if(this.rgbledAssignedPin.indexOf(pin) == -1){
                        src_init += `ChainableLED rgbled${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}, 10);\n`
                        src_setup += `rgbled${pin}.init();\n`
                        this.rgbledAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_sendIR':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.sendIRInit) {
                        src_include += `#include <IRremote.hpp>\n`
                        src_setup += `IrSender.begin(${pin});\n`
                        this.sendIRInit = true;
                    }
                    break;
                case 'makerBoardAdvance_checkReceivedIR':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.checkReceivedIRInit) {
                        src_include += `#include <IRremote.hpp>\n`
                        src_setup += `IrReceiver.begin(${pin}, false); \n`
                        this.checkReceivedIRInit = true;
                    }
                    break;

                case 'makerBoardAdvance_playMp3':
                case 'makerBoardAdvance_volumeMp3':
                case 'makerBoardAdvance_settingMp3':
                    type = this.processValueInfo(blockInfo['inputs']['TYPE'], allBlocksObject);
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (this.MP3PlayerType == null || this.MP3PlayerType == 'undefined'){
                        this.MP3PlayerType = type;
                    }
                    else if (this.MP3PlayerType != type){
                        // console.log(this.MP3PlayerType, type);
                        alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                        throw Error("MP3 Player Type Error");
                    }
                    if (!this.mp3playerInit) {
                        if (type == "SEEED"){
                            src_include += `#include <SoftwareSerial.h>\n#include <WT2605C_Player.h>\n`
                            src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nWT2605C<SoftwareSerial> Mp3Player${pin};\n`
                            src_setup += `SSerial${pin}.begin(115200);\nMp3Player${pin}.init(SSerial${pin});\n`
                        }else{
                            src_include += `#include <SoftwareSerial.h>\n#include <DFRobotDFPlayerMini.h>\n`
                            src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nDFRobotDFPlayerMini Mp3Player${pin};\n`
                            src_setup += `SSerial${pin}.begin(9600);\nMp3Player${pin}.begin(SSerial${pin});\n`;
                        }
                        this.mp3playerInit = true;
                        this.mp3playerAssignedPin.push(pin);
                    }
                    else if(this.mp3playerAssignedPin.indexOf(pin) == -1){
                        if (type == "SEEED"){
                            src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nWT2605C<SoftwareSerial> Mp3Player${pin};\n`
                            src_setup += `SSerial${pin}.begin(115200);\nMp3Player${pin}.init(SSerial${pin});\n`
                        }else{
                            src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nDFRobotDFPlayerMini Mp3Player${pin};\n`
                            src_setup += `SSerial${pin}.begin(9600);\nMp3Player${pin}.begin(SSerial${pin});\n`;
                        }
                        this.mp3playerAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_settingGroveMp3':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (this.MP3PlayerType == null || this.MP3PlayerType == 'undefined'){
                        this.MP3PlayerType = "SEEED";
                    }
                    else if (this.MP3PlayerType != "SEEED"){
                        // console.log(this.MP3PlayerType, "SEEED");
                        alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                        throw Error("MP3 Player Type Error");
                    }
                    if (!this.mp3playerInit) {
                        src_include += `#include <SoftwareSerial.h>\n#include <WT2605C_Player.h>\n`
                            src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nWT2605C<SoftwareSerial> Mp3Player${pin};\n`
                        src_setup += `SSerial${pin}.begin(115200);\nMp3Player${pin}.init(SSerial${pin});\n`
                        this.mp3playerInit = true;
                        this.mp3playerAssignedPin.push(pin);
                    }else if(this.mp3playerAssignedPin.indexOf(pin) == -1){
                        src_init += `SoftwareSerial SSerial${pin}(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \nWT2605C<SoftwareSerial> Mp3Player${pin};\n`
                        src_setup += `SSerial${pin}.begin(115200);\nMp3Player${pin}.init(SSerial${pin});\n`
                        this.mp3playerAssignedPin[1] = pin;
                    }
                    break;
                case 'makerBoardAdvance_checkSpeechRecognizer':
                case 'makerBoardAdvance_readSpeechRecognizer':
                    pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                    if (!this.speechRecognizerInit) {
                        src_include += `#include <SoftwareSerial.h>\n`
                        src_init += `const char *voiceBuffer[] =
                        {
                            "Turn on the light",
                            "Turn off the light",
                            "Play music",
                            "Pause",
                            "Next",
                            "Previous",
                            "Up",
                            "Down",
                            "Turn on the TV",
                            "Turn off the TV",
                            "Increase temperature",
                            "Decrease temperature",
                            "What's the time",
                            "Open the door",
                            "Close the door",
                            "Left",
                            "Right",
                            "Stop",
                            "Start",
                            "Mode 1",
                            "Mode 2",
                            "Go",
                        };\n`
                        src_init += `SoftwareSerial speechRecognizer(${this.INOUT_PINS[pin]}, ${this.OUTPUT_PINS[pin]}); // RX, TX \n`
                        src_setup += `speechRecognizer.begin(9600);\n speechRecognizer.listen();\n`
                        this.speechRecognizerInit = true;
                    }
                    break;
/*****************************************************************************************************/
/* TinyML */
/*****************************************************************************************************/
                case 'tinyml_classify':
                case 'tinyml_isLabel':
                case 'tinyml_classifyOnArduino':
                case 'tinyml_isLabelOnArduino':
                case 'tinyml_updateInference':
                    if (!this.tinymlInit) {
                        // TinyMLの初期化（プレースホルダー配置）
                        src_init += `
                // ========================================
                // TinyML Model Placeholder
                // ========================================
                // TINYML_MODEL_CODE_PLACEHOLDER

                `;
                        this.tinymlInit = true;
                        this.tinymlDeployed = true;
                    }
                    // 学習に使ったセンサー種別に応じて初期化コードを出し分ける。
                    // - 加速度センサー: MMA7660 をインクルードして init()
                    // - マイク       : Grove Port3 から analogRead し、50ms ごとに
                    //                  RMS / ZCR / Peak を計算する tinyml_mic_sample
                    //                  ヘルパを定義 (収集側スケッチと同じ式)
                    if (!this.tinymlSensorInit) {
                        const sensorType = (typeof window !== 'undefined'
                            && window.TinyMLShared
                            && window.TinyMLShared.dataSensorType) || 'accelerometer';
                        if (sensorType === 'microphone') {
                            // 注意: board.GROVE_CON3_SIG は **関数本体内のみ** で参照する。
                            // sb2cpp prelude (kurikit_makerBoard/index.js initialize()) の
                            // pin() ヘルパや analogRead スニペットと同じ流儀。
                            // グローバル const での初期化は静的初期化順序問題を招きうる。
                            src_init += `
// TinyML マイク用ヘルパ (Grove Analog Microphone, Port3)
float ax, ay, az;
void tinyml_mic_sample(float* rms_out, float* zcr_out, float* peak_out) {
    const unsigned long BLOCK_MS = 50;
    int16_t samples[200];
    uint16_t count = 0;
    int32_t sum = 0;
    unsigned long t0 = millis();
    while (millis() - t0 < BLOCK_MS && count < 200) {
        int s = analogRead(board.GROVE_CON3_SIG);
        samples[count++] = (int16_t)s;
        sum += s;
    }
    if (count == 0) { *rms_out = 0; *zcr_out = 0; *peak_out = 0; return; }
    int16_t mean = (int16_t)(sum / count);
    int32_t sum_sq = 0; int16_t peak = 0; uint16_t zcr = 0;
    int16_t last_ac = 0; bool first = true;
    for (uint16_t i = 0; i < count; i++) {
        int16_t ac = samples[i] - mean;
        sum_sq += (int32_t)ac * ac;
        int16_t a = ac < 0 ? -ac : ac;
        if (a > peak) peak = a;
        if (!first) {
            if ((last_ac <= 0 && ac > 0) || (last_ac >= 0 && ac < 0)) zcr++;
        }
        last_ac = ac; first = false;
    }
    float rms = sqrt((float)sum_sq / count);
    *rms_out  = rms / 512.0f;
    *peak_out = (float)peak / 512.0f;
    *zcr_out  = (float)zcr / (float)count;
}
`;
                            src_setup += `pinMode(board.GROVE_CON3_SIG, INPUT);\n`;
                        } else {
                            // 加速度センサー (既存パス)
                            // accelInit と排他: 既に他ブロック由来で MMA7660 init 済みなら重複させない
                            if (!this.accelInit) {
                                src_init += `#include <MMA7660.h>\nMMA7660 accelemeter;\nfloat ax, ay, az;\n`;
                                src_setup += `accelemeter.init();\n`;
                                this.accelInit = true;
                            }
                        }
                        this.tinymlSensorInit = true;
                    }
                    break;
            }

            let nextBlockID = allBlocksObject[id]['next'];
            if (nextBlockID) {
                // 次のブロックの結果を一回の呼び出しで取得
                [next_src_include, next_src_init, next_src_setup] = this.initConvert(nextBlockID, allBlocksObject);
                src_include += next_src_include;
                src_init += next_src_init;
                src_setup += next_src_setup;
            }
        }
        return [src_include, src_init, src_setup];
    }

    convertSnippet(id, allBlocksObject) {
        let snippet = '';
        if (id) {
            try {
                const blockInfo = allBlocksObject[id];
                const opcode = blockInfo['opcode'];

                let variableName, listName, innerSnippet, value, value2,
                    funcName, text, text2, pin, servo, output, duration, axis, cmd, num,
                    second, angle1, angle2,
                    YY, MM, DD, H, M, S;
                // case 内の bare 代入で使う作業変数（strict mode 対策で明示宣言）
                let motor, servo1, servo2, servo3, angle, angle3, angle4, angle5, angle6, angle7, angle8, color;
                let sec, type, label;
                //追加
                let mscale;
                let level;
                let red,green,blue;
                let column, row;

                switch (opcode) {
                    case 'argument_reporter_string_number':
                        snippet = this.modifyArgumentName(blockInfo['fields']['VALUE'][0]);
                        break;
                    case 'argument_reporter_boolean':
                        snippet = this.modifyArgumentName(blockInfo['fields']['VALUE'][0]);
                        break;
                    case 'control_forever':
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject);
                        snippet = 'while (1){\n' + this.indent(innerSnippet, 2) + '}\n';
                        break;
                    case 'control_repeat':
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject);
                        let cntName = `cnt_${this.loopCounterIndex}`;
                        this.loopCounterIndex++;
                        snippet = `for (int ${cntName}=0;${cntName}<${this.processValueInfo(blockInfo['inputs']['TIMES'], allBlocksObject)};${cntName}++){\n` + this.indent(innerSnippet, 2) + '}\n';
                        break;
                    case 'control_repeat_until':
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject);
                        snippet = `while (!(${this.processValueInfo(blockInfo['inputs']['CONDITION'], allBlocksObject)})){\n` + this.indent(innerSnippet, 2) + '}\n';
                        break;
                    case 'control_if':
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject);
                        snippet = `if (${this.processValueInfo(blockInfo['inputs']['CONDITION'], allBlocksObject)}){\n` + this.indent(innerSnippet, 2) + '}\n';
                        break;
                    case 'control_if_else':
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject); // not SUBSTACK1
                        snippet = `if (${this.processValueInfo(blockInfo['inputs']['CONDITION'], allBlocksObject)}){\n` + this.indent(innerSnippet, 2) + '} else {\n';
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK2'], allBlocksObject);
                        snippet += this.indent(innerSnippet, 2) + '}\n';
                        break;
                    case 'control_stop':
                        snippet = 'return 0;\n';
                        break;
                    case 'control_wait_until':
                        snippet = `while (!(${this.processValueInfo(blockInfo['inputs']['CONDITION'], allBlocksObject)})){\n` + this.indent('delay(1);', 4) + `}\n`
                        break;
                    case 'control_wait':
                        snippet = `delay(${this.processValueInfo(blockInfo['inputs']['DURATION'], allBlocksObject)}*1000UL);\n`
                        break;
                    // --- タイマー割り込み機能(試験段階)のためアトミック書き込みに対応 ---
                    // 元の data_setvariableto:
                    // case 'data_setvariableto':
                    //     variableName = this.modifyVariableName(blockInfo['fields']['VARIABLE'][0]);
                    //     value = this.processValueInfo(blockInfo['inputs']['VALUE'], allBlocksObject);
                    //     if (this.variables.includes(variableName)){
                    //         if (value === 'rev_data'){
                    //             snippet = `if (!${value}.toFloat()) {
                    //     errorStatus("e変数に文字を入れないでください");
                    // }else{
                    //     ${variableName} = ${value}.toFloat();
                    // }\n`
                    //         }else if (/^".*"$/.test(value)){
                    //             alert("変数ブロックに文字を入れないでください");
                    //             this.writeFlag = false;
                    //         }else{
                    //             snippet = `${variableName} = ${value};\n`
                    //         }
                    //     }
                    //     else{
                    //         this.variables.push(variableName);
                    //         if (/^".*"$/.test(value)){
                    //             alert("変数ブロックに文字を入れないでください");
                    //             this.writeFlag = false;
                    //         } else {
                    //             snippet = `float ${variableName} = ${value};\n`;
                    //         }
                    //     }
                    //     break;
                    case 'data_setvariableto': {
                        const rawSetVar = blockInfo['fields']['VARIABLE'][0];
                        variableName = this.modifyVariableName(rawSetVar);
                        value = this.processValueInfo(blockInfo['inputs']['VALUE'], allBlocksObject);
                        const atomicSet = !this.inTimerHandler && this.timerSharedVars.has(rawSetVar);
                        if (this.variables.includes(variableName)){
                            if (value === 'rev_data'){    // シリアル経由で文字列が送られるScratchからのメッセージブロックの時
                                const assignLine = atomicSet
                                    ? `_writeAtomic(&${variableName}, ${value}.toFloat());`
                                    : `${variableName} = ${value}.toFloat();`;
                                snippet = `if (!${value}.toFloat()) {
    errorStatus("e変数に文字を入れないでください");
}else{
    ${assignLine}
}\n`
                            }else if (/^".*"$/.test(value)){
                                alert("変数ブロックに文字を入れないでください");
                                this.writeFlag = false;
                            }else{
                                snippet = atomicSet
                                    ? `_writeAtomic(&${variableName}, ${value});\n`
                                    : `${variableName} = ${value};\n`;
                            }
                        }
                        else{
                            // 変数初期化
                            this.variables.push(variableName);
                            snippet = atomicSet
                                ? `_writeAtomic(&${variableName}, 0.0);\n`
                                : `float ${variableName} = 0.0;\n`;
                        }
                        break;
                    }
                    // 元の data_changevariableby:
                    // case 'data_changevariableby':
                    //     variableName = this.modifyVariableName(blockInfo['fields']['VARIABLE'][0]);
                    //     value = this.processValueInfo(blockInfo['inputs']['VALUE'], allBlocksObject);
                    //     if (value === 'rev_data'){
                    //         snippet = `if (!${value}.toFloat()) {
                    //     errorStatus("e変数に文字を入れないでください");
                    // }else{
                    //     ${variableName} += ${value}.toFloat();
                    // }\n`
                    //     }else if (/^".*"$/.test(value)){
                    //         alert("変数ブロックに文字を入れないでください");
                    //         this.writeFlag = false;
                    //     }else{
                    //         snippet = `${variableName} += ${value};\n`
                    //     }
                    //     break;
                    case 'data_changevariableby': {
                        const rawChgVar = blockInfo['fields']['VARIABLE'][0];
                        variableName = this.modifyVariableName(rawChgVar);
                        value = this.processValueInfo(blockInfo['inputs']['VALUE'], allBlocksObject);
                        const atomicChg = !this.inTimerHandler && this.timerSharedVars.has(rawChgVar);
                        if (value === 'rev_data'){    // シリアル経由で文字列が送られるScratchからのメッセージブロックの時
                            const assignLine = atomicChg
                                ? `_writeAtomic(&${variableName}, _readAtomic(&${variableName}) + ${value}.toFloat());`
                                : `${variableName} += ${value}.toFloat();`;
                            snippet = `if (!${value}.toFloat()) {
    errorStatus("e変数に文字を入れないでください");
}else{
    ${assignLine}
}\n`
                        }else if (/^".*"$/.test(value)){
                            alert("変数ブロックに文字を入れないでください");
                            this.writeFlag = false;
                        }else{
                            snippet = atomicChg
                                ? `_writeAtomic(&${variableName}, _readAtomic(&${variableName}) + ${value});\n`
                                : `${variableName} += ${value};\n`;
                        }
                        break;
                    }
                    case 'data_deleteoflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['INDEX'], allBlocksObject);
                        snippet = `${listName}.erase(${listName}.begin() + ${value} - 1);\n`;
                        break;
                    case 'data_deletealloflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        snippet = `${listName}.clear();\n`;
                        break;
                    case 'data_insertatlist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['INDEX'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['ITEM'], allBlocksObject);
                        snippet = `${listName}.insert(${value}-1, ${value2});\n`;
                        break;
                    case 'data_itemnumoflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['ITEM'], allBlocksObject);
                        snippet = `findIndex(${listName}, ${value})`;
                        break;
                    case 'data_addtolist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['ITEM'], allBlocksObject);
                        snippet = `${listName}.push_back(${value});\n`;
                        break;
                    case 'data_lengthoflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        snippet = `${listName}.size()`;
                        break;
                    case 'data_itemoflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['INDEX'], allBlocksObject);
                        snippet = `${listName}[${value}-1]`;
                        break;
                    case 'data_replaceitemoflist':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['INDEX'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['ITEM'], allBlocksObject);
                        snippet = `${listName}[${value}-1] = ${value2};\n`;
                        break;
                    case 'data_listcontainsitem':
                        listName = this.modifyListName(blockInfo['fields']['LIST'][0]);
                        value = this.processValueInfo(blockInfo['inputs']['ITEM'], allBlocksObject);
                        snippet = `(findIndex(${listName}, ${value}) != 0)`;
                        break;
                    case 'operator_add':
                        value = this.processValueInfo(blockInfo['inputs']['NUM1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['NUM2'], allBlocksObject);
                        snippet = `(${value} + ${value2})`;
                        break;
                    case 'operator_subtract':
                        value = this.processValueInfo(blockInfo['inputs']['NUM1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['NUM2'], allBlocksObject);
                        snippet = `(${value} - ${value2})`;
                        break;
                    case 'operator_multiply':
                        value = this.processValueInfo(blockInfo['inputs']['NUM1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['NUM2'], allBlocksObject);
                        snippet = `(${value} * ${value2})`;
                        break;
                    case 'operator_divide':
                        value = this.processValueInfo(blockInfo['inputs']['NUM1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['NUM2'], allBlocksObject);
                        snippet = `((float)${value} / (float)${value2})`;
                        break;
                    case 'operator_mod':
                        value = this.processValueInfo(blockInfo['inputs']['NUM1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['NUM2'], allBlocksObject);
                        snippet = `((int)${value} % (int)${value2})`;
                        break;
                    case 'operator_round':
                        value = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        snippet = `round(${value})`;
                        break;
                    case 'operator_mathop':
                        value = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        let opName = blockInfo['fields']['OPERATOR'][0];
                        if (opName === '10 ^') {
                            snippet = `pow(10.0, ${value})`;
                        } else {
                            let other = { 'abs': 'fabs', 'ceiling': 'ceil', 'ln': 'log', 'log': 'log10', 'e ^': 'exp'};
                            let trigonal = ['sin', 'cos', 'tan'];
                            let arc_trigonal = ['asin', 'acos', 'atan'];
                            if (opName in other) opName = other[opName];
                            if (trigonal.includes(opName)) snippet = `${opName}(${value}*PI/180.0)`;
                            if (arc_trigonal.includes(opName)) snippet = `${opName}(${value})*180.0/PI`;
                            else snippet = `${opName}(${value})`;
                        }
                        break;
                    case 'operator_random':
                        value = this.processValueInfo(blockInfo['inputs']['FROM'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['TO'], allBlocksObject);
                        snippet = `_random(${value}, ${value2})`;
                        break;
                    case 'operator_or':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['OPERAND2'], allBlocksObject);
                        snippet = `(${value} || ${value2})`;
                        break;
                    case 'operator_and':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['OPERAND2'], allBlocksObject);
                        snippet = `(${value} && ${value2})`;
                        break;
                    case 'operator_not':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND'], allBlocksObject);
                        snippet = `(!${value})`;
                        break;
                    case 'operator_join':
                        value = this.processValueInfo(blockInfo['inputs']['STRING1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['STRING2'], allBlocksObject);
                        snippet = `(String(${value}) + String(${value2}))`;
                        break;
                    // case 'operator_letter_of':
                    //     value = this.processValueInfo(blockInfo['inputs']['LETTER'], allBlocksObject);
                    //     value2 = this.processValueInfo(blockInfo['inputs']['STRING'], allBlocksObject);
                    //     snippet = `(String(${value}).charAt(${value2}))`;
                    //     break;
                    // case 'operator_length':
                    //     value = this.processValueInfo(blockInfo['inputs']['STRING'], allBlocksObject);
                    //     snippet = `(String(${value}).length)`;
                    //     break;
                    // case 'operator_contains':
                    //     value = this.processValueInfo(blockInfo['inputs']['STRING1'], allBlocksObject);
                    //     value2 = this.processValueInfo(blockInfo['inputs']['STRING2'], allBlocksObject);
                    //     snippet = `(String(${value}).indexOf(String(${value2})) != -1)`;
                    //     break;
                    case 'operator_equals':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['OPERAND2'], allBlocksObject);
                        snippet = `(${value} == ${value2})`;
                        break;
                    case 'operator_lt':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['OPERAND2'], allBlocksObject);
                        snippet = `(${value} < ${value2})`;
                        break;
                    case 'operator_gt':
                        value = this.processValueInfo(blockInfo['inputs']['OPERAND1'], allBlocksObject);
                        value2 = this.processValueInfo(blockInfo['inputs']['OPERAND2'], allBlocksObject);
                        snippet = `(${value} > ${value2})`;
                        break;
                    case 'procedures_call':
                        funcName = this.modifyFunctionName(blockInfo['mutation']['proccode'].split(' ')[0]);
                        value = [];
                        const argIDs = JSON.parse(blockInfo['mutation']['argumentids']);
                        for (let i = 0; i < argIDs.length; i++) {
                            value.push(this.processValueInfo(blockInfo['inputs'][argIDs[i]], allBlocksObject));
                        }
                        snippet = funcName + '(' + value.join(', ') + ');\n';
                        break;

/************************************************************************************************/
/* Maker Board command*/
/************************************************************************************************/
                    case 'makerBoard_starthat':
                        break;
                    case 'makerBoard_loopcode':
                        return snippet;
                    case 'makerBoard_servo':
                        servo = this.processValueInfo(blockInfo['inputs']['SERVO'], allBlocksObject);
                        angle = this.processValueInfo(blockInfo['inputs']['ANGLE'], allBlocksObject);
                        if (angle.includes('"')){
                            throw TypeError("サーボ角度が無効です")
                        }
                        snippet = `Servo${servo}.write(${angle});\n`;
                        break;
                    case 'makerBoard_motorforwardsimple':
                        motor = this.processValueInfo(blockInfo['inputs']['MOTOR'], allBlocksObject);
                        snippet = `digitalWrite(board.DCM${motor}_A, HIGH);\ndigitalWrite(board.DCM${motor}_B, LOW);\n`;
                        break;
                    case 'makerBoard_motorbackwardsimple':
                        motor = this.processValueInfo(blockInfo['inputs']['MOTOR'], allBlocksObject);
                        snippet = `digitalWrite(board.DCM${motor}_A, LOW);\ndigitalWrite(board.DCM${motor}_B, HIGH);\n`;
                        break;
                    case 'makerBoard_motorforward':
                        motor = this.processValueInfo(blockInfo['inputs']['MOTOR'], allBlocksObject);
                        duration = this.processValueInfo(blockInfo['inputs']['DURATION'], allBlocksObject);
                        if (duration.includes('"')){ throw TypeError("モータースピードが無効です") }
                        if(duration > 100){duration = 100;}
                        if(duration < -100){duration = -100;}
                        snippet = `Motor${motor}.set(${duration}, Motor${motor}.FORWARD);\n`;
                        break;
                    case 'makerBoard_motorbackward':
                        motor = this.processValueInfo(blockInfo['inputs']['MOTOR'], allBlocksObject);
                        duration = this.processValueInfo(blockInfo['inputs']['DURATION'], allBlocksObject);
                        if (duration.includes('"')){ throw TypeError("モータースピードが無効です") }
                        if(duration > 100){duration = 100;}
                        if(duration < -100){duration = -100;}
                        snippet = `Motor${motor}.set(${duration}, Motor${motor}.BACKWARD);\n`;
                        break;
                    case 'makerBoard_motorstop':
                        motor = this.processValueInfo(blockInfo['inputs']['MOTOR'], allBlocksObject);
                        snippet = '';
                        if (this.motorInit) {
                            snippet += `Motor${motor}.set(0, Motor${motor}.FORWARD);\n`;
                        }
                        snippet += `digitalWrite(board.DCM${motor}_A, HIGH);\ndigitalWrite(board.DCM${motor}_B, HIGH);\n`;
                        break;
                    case 'makerBoard_led':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        snippet = `digitalWrite(${pin}, ${output});\n`
                        break;
                    case 'makerBoard_buttonbool':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['BOOL'], allBlocksObject);
                        snippet = `(analogRead(${this.INPUT_PINS[pin]}) >= 512) == ${output}`;
                        break;
                    case 'makerBoard_touch':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['BOOL'], allBlocksObject);
                        snippet = `(analogRead(${this.INPUT_PINS[pin]}) >= 512) == ${output}`;
                        break;
    
                    case 'makerBoard_joystick':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        axis = this.processValueInfo(blockInfo['inputs']['AXIS'], allBlocksObject);
                        snippet = `joystickPos(pin(${this.INPUT_PINS[pin]}, ${axis}))`;
                        break;
                    case 'makerBoard_joystickpush':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `analogRead(pin(${this.INPUT_PINS[pin]}, 0)) > 1022`;
                        break;
                    case 'makerBoard_rotary':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `map(analogRead(${this.INPUT_PINS[pin]}), 0, 1023, 0, 300)`
                        break;
                    case 'makerBoard_sound':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `analogRead(${this.INPUT_PINS[pin]})`
                        break;
    
/************************************************************************************************/
/* Maker Board Analog command*/
/************************************************************************************************/

                    case 'makerBoardAnalog_analogread':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `analogRead(${this.INPUT_PINS[pin]})`
                        break;
                    case 'makerBoardAnalog_lightanalog':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `analogRead(${this.INPUT_PINS[pin]})`;
                        break;
                    case 'makerBoardAnalog_getultrasonicYukai':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `var_ultrasonic${pin} = YukaiUltrasonicVal(ultrasonic${pin});\n`
                        break;
                    case 'makerBoardAnalog_ultrasonicYukai':
                        if(!this.ultrasonicYukaiInit){
                            this.initialErrorAlert("超音波")
                            throw Error("Initialize error")
                        }
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `var_ultrasonic${pin}`
                        break;
                    case 'makerBoardAnalog_getultrasonic':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `var_ultrasonic${pin} = ultrasonicVal(ultrasonic${pin});\n`
                        break;
                    case 'makerBoardAnalog_ultrasonic':
                        if(!this.ultrasonicSeeedInit){
                            this.initialErrorAlert("超音波")
                            throw Error("Initialize error")
                        }
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `var_ultrasonic${pin}`
                        break;
                    case 'makerBoardAnalog_getaccel':
                            snippet = `accelemeter.getAcceleration(&ax, &ay, &az);\n`
                            break;
                    case 'makerBoardAnalog_accel':
                        axis = this.processValueInfo(blockInfo['inputs']['AXIS'], allBlocksObject);
                        if (axis == 'role'){
                            snippet = `atan2(ay, az) * 180.0 / PI`;
                        } else if (axis == 'pitch'){
                            snippet = `atan2(-ax, sqrt(ay*ay + az*az)) * 180.0 / PI`;
                        }else{
                            snippet = `a${axis}`;
                        }
                        break;
                    case 'makerBoardAnalog_getgyro':
                        snippet = `gyro.getAngularVelocity(&gx, &gy, &gz);\n`
                        break;
                    case 'makerBoardAnalog_gyro':
                        axis = this.processValueInfo(blockInfo['inputs']['AXIS'], allBlocksObject);
                        snippet = `g${axis}`;
                        break;
                    case 'makerBoardAnalog_getcolor':
                        snippet = `uint16_t clear, red, green, blue;
tcs.setInterrupt(false);
delay(60);  // takes 50ms to read
tcs.getRawData(&red, &green, &blue, &clear);
tcs.setInterrupt(true);\n`;
                        break;
                    case 'makerBoardAnalog_color':
                        value = this.processValueInfo(blockInfo['inputs']['COLOR'], allBlocksObject);
                        snippet = `${value}`;
                        break;
                    case 'makerBoardAnalog_getTempHumid':
                        snippet = `humidity = dht.readHumidity(); \n temperature = dht.readTemperature(); \n if (isnan(humidity)) {humidity = lastHumidity;} \n else {lastHumidity = humidity;} \n if (isnan(temperature)) {temperature = lastTemperature;} \n else {lastTemperature = temperature;} \n`;
                        break;
                    case 'makerBoardAnalog_tempHumid':
                        value = this.processValueInfo(blockInfo['inputs']['TEMPHUMID'], allBlocksObject);
                        if(value == "temperature"){
                            snippet = `temperature`;
                        }
                        else{
                            snippet = `humidity`;
                        }
                        break;
                    case 'makerBoardAnalog_getSoundDirection':
                        snippet = `getSoundDirection();\n`;
                        break;
                    case 'makerBoardAnalog_soundDirection':
                        value = this.processValueInfo(blockInfo['inputs']['DIRECTION'], allBlocksObject);
                        if (value == `direction`){
                            snippet = `soundDegree`;
                        }
                        else if (value == `activity`){
                            snippet = `activity`;
                        }
                        break;

/************************************************************************************************/
/* Maker Board Digital command*/
/************************************************************************************************/
                    case 'makerBoardDigital_outerled':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        snippet = `digitalWrite(${this.INOUT_PINS[pin]}, ${output});\n`
                        break;
                    case 'makerBoardDigital_ledbuttonbool':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['BOOL'], allBlocksObject);
                        snippet = `(analogRead(${this.INPUT_LEDBUTTON_PINS[pin]}) <= 512 ) == ${output}`;
                        break;
                    case 'makerBoardDigital_buttonbool':
                    case 'makerBoardDigital_light':
                    case'makerBoardDigital_magnet':
                    case 'makerBoardDigital_ir':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['BOOL'], allBlocksObject);
                        snippet = `(analogRead(${this.INPUT_PINS[pin]}) >= 512) == ${output}`;
                        break;


/************************************************************************************************/
/* Maker Board Advance command*/
/************************************************************************************************/
                    case 'makerBoardAdvance_nowtime':
                        snippet = 'millis()';
                        break;
                    case 'makerBoardAdvance_pi':
                        snippet = `PI`
                        break;
                    case 'makerBoardAdvance_log':
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        value = this.processValueInfo(blockInfo['inputs']['ID'], allBlocksObject);
                        snippet = `Serial.println("${value}" + String(${text}));\ndelay(10);\n`
                        break;
                    case 'makerBoardAdvance_serialAvailable':
                        this.insideSerialAvailable = true;
                        innerSnippet = this.processValueInfo(blockInfo['inputs']['SUBSTACK'], allBlocksObject);
                        this.insideSerialAvailable = false;
                            // readString() はタイムアウト(既定1秒)まで来た全バイトを1つの文字列として
                            // 読んでしまうため、短時間に複数行送られると "1\n0\n2" のように連結され
                            // 数値変換に失敗する。1行だけ読む readStringUntil で行単位に区切る。
                            snippet = `if (Serial.available() > 0){
String rev_data = Serial.readStringUntil('\\n');
rev_data.trim();
`+ innerSnippet + '\n}';
                        break;
                    case 'makerBoardAdvance_timerLoop':
                        // トップレベルで処理されるブロック.
                        // 「繰り返し動かす」内側など別ブロックのSUBSTACKに含まれた
                        // ケースは generate() 側で parent チェックして警告するので
                        // ここでは何も出力しない.
                        snippet = '';
                        break;
                    case 'makerBoardAdvance_revMessage':
                        if (!this.insideSerialAvailable) {
                            alert('「パソコンからのメッセージ」ブロックは「パソコンからメッセージを受信したとき」ブロックの中で使用してください。');
                            throw Error('revMessage: serialAvailableブロックの外で使用されています');
                        }
                        snippet = 'rev_data';
                        break;
                    case 'makerBoardAdvance_toNumber':
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        snippet = `_toNumber(${text})`;
                        break;
                    case 'makerBoardAdvance_updateList':
                        if (!this.insideSerialAvailable) {
                            alert('「リストをパソコンからのメッセージで更新」ブロックは「パソコンからメッセージを受信したとき」ブロックの中で使用してください。');
                            throw Error('updateList: serialAvailableブロックの外で使用されています');
                        }
                        {
                            const shadowID = blockInfo['inputs']['LIST'][1];
                            const shadowBlock = allBlocksObject[shadowID];
                            const rawListName = shadowBlock['fields']['scratchLists'][0];
                            listName = this.modifyListName(rawListName);
                        }
                        snippet = `_updateList(${listName}, rev_data);\n`;
                        break;
                    case 'makerBoardAdvance_servowithtime':
                        servo = this.processValueInfo(blockInfo['inputs']['SERVO'], allBlocksObject);
                        second = this.processValueInfo(blockInfo['inputs']['SECOND'], allBlocksObject);
                        angle1 = this.processValueInfo(blockInfo['inputs']['ANGLE1'], allBlocksObject);
                        angle2 = this.processValueInfo(blockInfo['inputs']['ANGLE2'], allBlocksObject);
                        if (second.includes('"') || angle1.includes('"') || angle2.includes('"')){
                            throw TypeError("サーボモーターの設定された数字が無効です")
                        }

                        snippet = `rotateWithTime(Servo${servo}, ${second}, ${angle1}, ${angle2});\n`
                        break;
                    case 'makerBoardAdvance_servowithtime_two':
                        servo1 = this.processValueInfo(blockInfo['inputs']['SERVO1'], allBlocksObject);
                        servo2 = this.processValueInfo(blockInfo['inputs']['SERVO2'], allBlocksObject);
                        second = this.processValueInfo(blockInfo['inputs']['SECOND'], allBlocksObject);
                        angle1 = this.processValueInfo(blockInfo['inputs']['ANGLE1'], allBlocksObject);
                        angle2 = this.processValueInfo(blockInfo['inputs']['ANGLE2'], allBlocksObject);
                        angle3 = this.processValueInfo(blockInfo['inputs']['ANGLE3'], allBlocksObject);
                        angle4 = this.processValueInfo(blockInfo['inputs']['ANGLE4'], allBlocksObject);
                        if (second.includes('"') || angle1.includes('"') || angle2.includes('"')){
                            throw TypeError("サーボモーターの設定された数字が無効です")
                        }

                        snippet = `rotateWithTime2(Servo${servo1}, ${angle1}, ${angle2}, Servo${servo2}, ${angle3}, ${angle4}, ${second});\n`
                        break;
                    case 'makerBoardAdvance_servowithtime_three':
                        servo1 = this.processValueInfo(blockInfo['inputs']['SERVO1'], allBlocksObject);
                        servo2 = this.processValueInfo(blockInfo['inputs']['SERVO2'], allBlocksObject);
                        servo3 = this.processValueInfo(blockInfo['inputs']['SERVO3'], allBlocksObject);
                        second = this.processValueInfo(blockInfo['inputs']['SECOND'], allBlocksObject);
                        angle1 = this.processValueInfo(blockInfo['inputs']['ANGLE1'], allBlocksObject);
                        angle2 = this.processValueInfo(blockInfo['inputs']['ANGLE2'], allBlocksObject);
                        angle3 = this.processValueInfo(blockInfo['inputs']['ANGLE3'], allBlocksObject);
                        angle4 = this.processValueInfo(blockInfo['inputs']['ANGLE4'], allBlocksObject);
                        angle5 = this.processValueInfo(blockInfo['inputs']['ANGLE5'], allBlocksObject);
                        angle6 = this.processValueInfo(blockInfo['inputs']['ANGLE6'], allBlocksObject);

                        if (second.includes('"') || angle1.includes('"') || angle2.includes('"') || angle3.includes('"') || angle4.includes('"') || angle5.includes('"') || angle6.includes('"')){
                            throw TypeError("サーボモーターの設定された数字が無効です")
                        }

                        snippet = `rotateWithTime3(Servo${servo1}, ${angle1}, ${angle2}, Servo${servo2}, ${angle3}, ${angle4}, Servo${servo3}, ${angle5}, ${angle6}, ${second});\n`
                        break;
                    case 'makerBoardAdvance_servowithtime_four':
                        second = this.processValueInfo(blockInfo['inputs']['SECOND'], allBlocksObject);
                        angle1 = this.processValueInfo(blockInfo['inputs']['ANGLE1'], allBlocksObject);
                        angle2 = this.processValueInfo(blockInfo['inputs']['ANGLE2'], allBlocksObject);
                        angle3 = this.processValueInfo(blockInfo['inputs']['ANGLE3'], allBlocksObject);
                        angle4 = this.processValueInfo(blockInfo['inputs']['ANGLE4'], allBlocksObject);
                        angle5 = this.processValueInfo(blockInfo['inputs']['ANGLE5'], allBlocksObject);
                        angle6 = this.processValueInfo(blockInfo['inputs']['ANGLE6'], allBlocksObject);
                        angle7 = this.processValueInfo(blockInfo['inputs']['ANGLE7'], allBlocksObject);
                        angle8 = this.processValueInfo(blockInfo['inputs']['ANGLE8'], allBlocksObject);

                        if (second.includes('"') || angle1.includes('"') || angle2.includes('"') || angle3.includes('"') || angle4.includes('"') || angle5.includes('"') || angle6.includes('"')){
                            throw TypeError("サーボモーターの設定された数字が無効です")
                        }


                        snippet = `rotateWithTime4(Servo1, ${angle1}, ${angle2}, Servo2, ${angle3}, ${angle4}, Servo3, ${angle5}, ${angle6}, Servo4, ${angle7}, ${angle8}, ${second});\n`
                        break;
                    case 'makerBoardAdvance_servowithtime_two':
                        servo1 = this.processValueInfo(blockInfo['inputs']['SERVO1'], allBlocksObject);
                        servo2 = this.processValueInfo(blockInfo['inputs']['SERVO2'], allBlocksObject);
                        second = this.processValueInfo(blockInfo['inputs']['SECOND'], allBlocksObject);
                        snippet = `rotateTwoWithTime(Servo${servo1}, Servo${servo2}, ${second});\n`
                        break;
                    case 'makerBoardAdvance_setRTC_DS1307':
                        YY = this.processValueInfo(blockInfo['inputs']['YY'], allBlocksObject);
                        MM = this.processValueInfo(blockInfo['inputs']['MM'], allBlocksObject);
                        DD = this.processValueInfo(blockInfo['inputs']['DD'], allBlocksObject);
                        H = this.processValueInfo(blockInfo['inputs']['H'], allBlocksObject);
                        M = this.processValueInfo(blockInfo['inputs']['M'], allBlocksObject);
                        S = this.processValueInfo(blockInfo['inputs']['S'], allBlocksObject);
                        if (YY.includes('"') || MM.includes('"') || DD.includes('"') || H.includes('"') || M.includes('"') || S.includes('"')){
                            throw TypeError("RTCの設定日付が無効です")
                        }

                        snippet = `clock.fillByYMD(${YY},${MM},${DD});
clock.fillByHMS(${H},${M},${S});
clock.setTime();
`
                        break;
                    case 'makerBoardAdvance_getRTC_DS1307':
                        snippet = "clock.getTime();\n"
                        this.rtcGotVal = true;
                        break;
                    case 'makerBoardAdvance_valRTC_DS1307':
                        if(!this.rtcGotVal){
                            this.initialErrorAlert("RTCモジュール")
                            throw Error("Initilize error")
                        }
                        value = this.processValueInfo(blockInfo['inputs']['VALUE'], allBlocksObject);
                        if(value === "year") {
                            snippet = `clock.year+2000`;
                        }else{
                            snippet = `clock.${value}`;
                        }
                        break;
                    case 'makerBoardAdvance_rgbledselect':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        color = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        switch(color){
                            case "off":
                                red = 0;
                                green = 0;
                                blue = 0;
                                break;
                            case "blue":
                                red = 0;
                                green = 0;
                                blue = 255;
                                break;
                            case "green":
                                red = 0;
                                green = 255;
                                blue = 0;
                                break;
                            case "cyan":
                                red = 0;
                                green = 255;
                                blue = 255;
                                break;
                            case "red":
                                red = 255;
                                green = 0;
                                blue = 0;
                                break;
                            case "magenta":
                                red = 255;
                                green = 0;
                                blue = 255;
                                break;
                            case "yellow":
                                red = 255;
                                green = 255;
                                blue = 0;
                                break;
                            case "white":
                                red = 255;
                                green = 255;
                                blue = 255;
                                break;
                            }
                        if (num < 1){num = 1;}
                        snippet = `rgbled${pin}.setColorRGB(${num}-1, ${red}, ${green}, ${blue});\n`
                        break;
                    case 'makerBoardAdvance_rgbled':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        red = this.processValueInfo(blockInfo['inputs']['RED'], allBlocksObject);
                        green = this.processValueInfo(blockInfo['inputs']['GREEN'], allBlocksObject);
                        blue = this.processValueInfo(blockInfo['inputs']['BLUE'], allBlocksObject);
                        if (red.includes('"') || green.includes('"') || blue.includes('"')){
                            throw TypeError("ネオピクセルの色設定値が無効です")
                        }
                        if(red < -1){red = 0}
                        else if(red > 255){red = 255}
                        if(green < -1){green = 0}
                        else if(green > 255){green = 255}
                        if(blue < -1){blue = 0}
                        else if(blue > 255){blue = 255}

                        if (num < 1){num = 1;}
                        snippet = `rgbled${pin}.setColorRGB(${num}-1, ${red}, ${green}, ${blue});\n`
                        break;
                    case 'makerBoardAdvance_neopixelselect':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        color = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        switch(color){
                            case "off":
                                red = 0;
                                green = 0;
                                blue = 0;
                                break;
                            case "blue":
                                red = 0;
                                green = 0;
                                blue = 255;
                                break;
                            case "green":
                                red = 0;
                                green = 255;
                                blue = 0;
                                break;
                            case "cyan":
                                red = 0;
                                green = 255;
                                blue = 255;
                                break;
                            case "red":
                                red = 255;
                                green = 0;
                                blue = 0;
                                break;
                            case "magenta":
                                red = 255;
                                green = 0;
                                blue = 255;
                                break;
                            case "yellow":
                                red = 255;
                                green = 255;
                                blue = 0;
                                break;
                            case "white":
                                red = 255;
                                green = 255;
                                blue = 255;
                                break;
                            }

                        if (num < 1){num = 1;}
                        snippet = `pixels${pin}.setPixelColor(${num}-1, pixels${pin}.Color(${red}, ${green}, ${blue}));\npixels${pin}.show();\n`
                        break;
                    case 'makerBoardAdvance_neopixel':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        red = this.processValueInfo(blockInfo['inputs']['RED'], allBlocksObject);
                        green = this.processValueInfo(blockInfo['inputs']['GREEN'], allBlocksObject);
                        blue = this.processValueInfo(blockInfo['inputs']['BLUE'], allBlocksObject);
                        if (red.includes('"') || green.includes('"') || blue.includes('"')){
                            throw TypeError("ネオピクセルの色設定値が無効です")
                        }
                        if(red < -1){red = 0}
                        else if(red > 255){red = 255}
                        if(green < -1){green = 0}
                        else if(green > 255){green = 255}
                        if(blue < -1){blue = 0}
                        else if(blue > 255){blue = 255}
                        if (num < 1){num = 1;}
                        snippet = `pixels${pin}.setPixelColor(${num}-1, pixels${pin}.Color(${red}, ${green}, ${blue}));\npixels${pin}.show();\n`
                        break;
                    case 'makerBoardAdvance_neopixelclear':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        // snippet = `pixels.clear(); \n`
                        snippet = `for(uint8_t i = 0; i < 50; i++){
    pixels${pin}.setPixelColor(i, pixels${pin}.Color(0, 0, 0));
}
pixels${pin}.show();\n`
                        break;
                    case 'makerBoardAdvance_sevensegnum':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        if (num.includes('"')){
                            throw TypeError("7セグLEDの数字が無効です")
                        }
                        snippet = `sevenseg${pin}.displayNum(${num});\n`
                        break;
                    case 'makerBoardAdvance_sevensegstr':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        // textに数字以外が入ると""が勝手につくので…
                        if(/"/.test(text)){
                            snippet = `sevenseg${pin}.displayStr(${text});\n`
                        }
                        else{
                            snippet = `sevenseg${pin}.displayStr("${text}");\n`
                        }
                            break;
                    case 'makerBoardAdvance_sevensegstrselect':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        snippet = `sevenseg${pin}.displayStr("${text}");\n`
                        break;
                    case 'makerBoardAdvance_sevensegclear':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet = `sevenseg${pin}.clearDisplay();\n`
                        break;
                    case 'makerBoardAdvance_lcdtext':
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        text2 = this.processValueInfo(blockInfo['inputs']['TEXT2'], allBlocksObject);
                        snippet = `lcd.setCursor(0, 0);\nlcd.print(${text});\nlcd.setCursor(0, 1);\nlcd.print(${text2});\n`
                        break;
                    case 'makerBoardAdvance_lcdchara':
                        column = this.processValueInfo(blockInfo['inputs']['COL'], allBlocksObject);
                        row = this.processValueInfo(blockInfo['inputs']['ROW'], allBlocksObject);
                        text = this.processValueInfo(blockInfo['inputs']['TEXT'], allBlocksObject);
                        if (column.includes('"') || row.includes('"')){
                            throw TypeError("LCDの行列番号が無効です")
                        }

                        snippet = `lcd.setCursor(${row}-1, ${column}-1);\nlcd.print(${text});\n`
                        break;
                    case 'makerBoardAdvance_lcdclear':
                        snippet = `lcd.clear();\n`
                        break;
                    case 'makerBoardAdvance_ledbar':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        level = this.processValueInfo(blockInfo['inputs']['LEVEL'], allBlocksObject);
                        if (level.includes('"')){
                            throw TypeError("LEDバーのレベル番号が無効です")
                        }
                        snippet = `ledbar${pin}.setLevel(${level});\n`
                        break;
                    case 'makerBoardAdvance_ledbarbit':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        let bit1 = 1 * this.processValueInfo(blockInfo['inputs']['BIT1'], allBlocksObject);
                        let bit2 = 2 * this.processValueInfo(blockInfo['inputs']['BIT2'], allBlocksObject);
                        let bit3 = 4 * this.processValueInfo(blockInfo['inputs']['BIT3'], allBlocksObject);
                        let bit4 = 8 * this.processValueInfo(blockInfo['inputs']['BIT4'], allBlocksObject);
                        let bit5 = 16 * this.processValueInfo(blockInfo['inputs']['BIT5'], allBlocksObject);
                        let bit6 = 32 * this.processValueInfo(blockInfo['inputs']['BIT6'], allBlocksObject);
                        let bit7 = 64 * this.processValueInfo(blockInfo['inputs']['BIT7'], allBlocksObject);
                        let bit8 = 128 * this.processValueInfo(blockInfo['inputs']['BIT8'], allBlocksObject);
                        let bit9 = 256 * this.processValueInfo(blockInfo['inputs']['BIT9'], allBlocksObject);
                        let bit10 = 512 * this.processValueInfo(blockInfo['inputs']['BIT10'], allBlocksObject);
                        let ledstate = bit1 + bit2 + bit3 + bit4 + bit5 + bit6 + bit7 + bit8 + bit9 + bit10;
                        snippet = `ledbar${pin}.setBits(${ledstate});\n`
                        break;
                    case 'makerBoardAdvance_buzzer':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        snippet = `digitalWrite(${this.INOUT_PINS[pin]}, ${output});\n`
                        break;
                    case 'makerBoardAdvance_speaker':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        mscale = this.processValueInfo(blockInfo['inputs']['MSCALE'], allBlocksObject);
                        sec = this.processValueInfo(blockInfo['inputs']['SEC'], allBlocksObject);
                        if (sec.includes('"')){
                            throw TypeError("スピーカーの秒数が無効です")
                        }

                        snippet = `sound(${this.INOUT_PINS[pin]}, ${mscale}, ${sec});\n`
                        break;
                    case 'makerBoardAdvance_recorderREC':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        output = this.processValueInfo(blockInfo['inputs']['OUTPUT'], allBlocksObject);
                        snippet +=`digitalWrite(${this.OUTPUT_PINS[pin]}, ${output});\n`;
                        break;
                    case 'makerBoardAdvance_recorderPlay':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        snippet +=`digitalWrite(${this.INOUT_PINS[pin]}, LOW);\n delay(100);\n digitalWrite(${this.INOUT_PINS[pin]}, HIGH);\n `;
                        break;
                    case 'makerBoardAdvance_sendIR':
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        snippet = `IrSender.sendNEC(0x00,${num}, 0);\n`;
                        break;
                    case 'makerBoardAdvance_checkReceivedIR':
                        snippet = `IrReceiver.decode()`;
                        break;
                    case 'makerBoardAdvance_readIR':
                        snippet = `IrReceiver.decodedIRData.command`;
                        break;
                    case 'makerBoardAdvance_resetReadIR':
                        snippet = `IrReceiver.resume();\n`;
                        break;
                    case 'makerBoardAdvance_playMp3':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        type = this.processValueInfo(blockInfo['inputs']['TYPE'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        if (this.MP3PlayerType == null){
                            this.MP3PlayerType = type;
                        }
                        else if (this.MP3PlayerType != type){
                            alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                            throw Error("MP3 Player Type Error");
                        }
                        if (num.includes('"')){
                            throw TypeError("MP3プレイヤーの曲番号が無効です")
                        }
                        if (type == 'SEEED'){
                            snippet = `Mp3Player${pin}.playSDRootSong(int(${num}));\n`;
                        }else {
                            snippet = `Mp3Player${pin}.play(int(${num})); \n`;
                        }
                        break;
                    case 'makerBoardAdvance_volumeMp3':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        type = this.processValueInfo(blockInfo['inputs']['TYPE'], allBlocksObject);
                        num = this.processValueInfo(blockInfo['inputs']['NUM'], allBlocksObject);
                        if (this.MP3PlayerType == null){
                            this.MP3PlayerType = type;
                        }
                        else if (this.MP3PlayerType != type){
                            alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                            throw Error("MP3 Player Type Error");
                        }
                        if (num.includes('"')){
                            throw TypeError("MP3プレイヤーのボリュームが無効です")
                        }
                        snippet = `Mp3Player${pin}.volume(int(${num}));\n`;
                        break
                    case 'makerBoardAdvance_settingMp3':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        type = this.processValueInfo(blockInfo['inputs']['TYPE'], allBlocksObject);
                        cmd = this.processValueInfo(blockInfo['inputs']['SETTING'], allBlocksObject);
                        if (this.MP3PlayerType == null){
                            this.MP3PlayerType = type;
                        }
                        else if (this.MP3PlayerType != type){
                            alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                            throw Error("MP3 Player Type Error");
                        }
                        switch (cmd) {
                            case '+': {
                                snippet = `Mp3Player${pin}.volumeUp();\n`;
                                break;
                                }
                            case '-': {
                                snippet = `Mp3Player${pin}.volumeDown();\n`;
                                    break;
                                }
                            case 'n': {
                                snippet = `Mp3Player${pin}.next();\n`;
                                    break;
                                }
                            case 'p': {
                                if (type == 'SEEED') snippet = `Mp3Player${pin}.pause_or_play();\n`;
                                else snippet = `if(Mp3Player.available()){\nif(Mp3Player.readType() != DFPlayerPlayFinished){\nMp3Player.pause();\n}\nelse{\nMp3Player.start();}\n}\n`;
                                    break;
                                }
                            case 'b': 
                                snippet = `Mp3Player${pin}.previous();\n`;
                                break;
                            }
                        break;
                    case 'makerBoardAdvance_settingGroveMp3':
                        pin = this.processValueInfo(blockInfo['inputs']['PIN'], allBlocksObject);
                        cmd = this.processValueInfo(blockInfo['inputs']['SETTING'], allBlocksObject);
                        if (this.MP3PlayerType == null){
                            this.MP3PlayerType = "SEEED";
                        }
                        else if (this.MP3PlayerType != "SEEED"){
                            alert("MP3プレイヤーの種類が違います。SEEEDを選択している場合は、Seeed studioのMP3プレイヤーを接続してください。");
                            throw Error("MP3 Player Type Error");
                        }
                        switch (cmd) {
                            case 'w': {
                                snippet = `Mp3Player${pin}.playMode(WT2605C_SINGLE_SHOT);\n`;
                                    break;
                                }
                            case 'x': {
                                snippet = `Mp3Player${pin}.playMode(WT2605C_SINGLE_CYCLE);\n`;
                                    break;
                                }
                            case 'y': {
                                snippet = `Mp3Player${pin}.playMode(WT2605C_CYCLE);\n`;
                                    break;
                                }
                            case 'z': {
                                snippet = `Mp3Player${pin}.playMode(WT2605C_RANDOM);\n`;
                                    break;
                                }
                            }
                        break;
                    case 'makerBoardAdvance_checkSpeechRecognizer':
                        snippet =  `speechRecognizer.available()`
                        break;
                    case 'makerBoardAdvance_readSpeechRecognizer':
                        snippet = 'voiceBuffer[speechRecognizer.read() - 1]';
                        break;
/************************************************************************************************/
/* Maker Board menu command*/
/************************************************************************************************/
                    case 'makerBoard_menu_led_pins':
                    case 'makerBoardAnalog_menu_led_pins':
                    case 'makerBoardAdvance_menu_led_pins':
                        snippet = blockInfo['fields']['led_pins'][0];
                        break;
                    case 'makerBoard_menu_inout_pins':
                    case 'makerBoardAnalog_menu_inout_pins':
                    case 'makerBoardDigital_menu_inout_pins':
                    case 'makerBoardAdvance_menu_inout_pins':
                        snippet = blockInfo['fields']['inout_pins'][0];
                        break;
                    case 'makerBoard_menu_input_pins':
                    case 'makerBoardAnalog_menu_input_pins':
                    case 'makerBoardDigital_menu_input_pins':
                    case 'makerBoardAdvance_menu_input_pins':
                        snippet = blockInfo['fields']['input_pins'][0];
                        break;
                    case 'makerBoardDigital_menu_input_ledbutton_pins':
                        snippet = blockInfo['fields']['input_ledbutton_pins'][0];
                        break;
                    case 'makerBoardAdvance_menu_rtc_date':
                        snippet = blockInfo['fields']['rtc_date'][0];
                        break;
                    case 'makerBoardAdvance_menu_seven_segment_text':
                        snippet = blockInfo['fields']['seven_segment_text'][0];
                        break;
                    case 'makerBoardAdvance_menu_led_level':
                        snippet = blockInfo['fields']['led_level'][0];
                        break;
                    case 'makerBoardAdvance_menu_led_bar_boolean':
                        snippet = blockInfo['fields']['led_bar_boolean'][0];
                        break;
                    case 'makerBoardAdvance_menu_rgb_led':
                        snippet = blockInfo['fields']['rgb_led'][0];
                        break;
                    case 'makerBoardAdvance_menu_neopixel_types':
                        snippet = blockInfo['fields']['neopixel_types'][0];
                        break;
                    case 'makerBoardAdvance_menu_music_scale':
                        snippet = blockInfo['fields']['music_scale'][0];
                        break;
                    case 'makerBoardAdvance_menu_recorder':
                        snippet = blockInfo['fields']['recorder'][0];
                        break;
                    case 'makerBoard_menu_servo':
                    case 'makerBoardAdvance_menu_servo':
                        snippet = blockInfo['fields']['servo'][0];
                        break;
                    case 'makerBoard_menu_motor':
                        snippet = blockInfo['fields']['motor'][0];
                        break;
                    case 'makerBoard_menu_output':
                    case 'makerBoardDigital_menu_output':
                    case 'makerBoardAdvance_menu_output':
                        snippet = blockInfo['fields']['output'][0];
                        break;
                    case 'makerBoard_menu_axis':
                            snippet = blockInfo['fields']['axis'][0];
                        break;
                    case 'makerBoardAnalog_menu_ultrasonic_types':
                        snippet = blockInfo['fields']['ultrasonic_types'][0];
                        break;
                    case 'makerBoardAnalog_menu_accel':
                            snippet = blockInfo['fields']['accel'][0];
                        break;
                    case 'makerBoardAnalog_menu_gyro':
                        snippet = blockInfo['fields']['gyro'][0];
                        break;
                    case 'makerBoardAdvance_menu_id':
                        snippet = blockInfo['fields']['id'][0];
                        break;
                    case 'makerBoardAnalog_menu_color':
                            snippet = blockInfo['fields']['color'][0];
                        break;
                    case 'makerBoardAnalog_menu_temp_humid':
                    case 'makerBoardAdvance_menu_temp_humid':
                        snippet = blockInfo['fields']['temp_humid'][0];
                        break;
                    case 'makerBoardAnalog_menu_sound_direction':
                        snippet = blockInfo['fields']['sound_direction'][0];
                        break;
                    case 'makerBoardAdvance_menu_mp3player':
                        snippet = blockInfo['fields']['mp3player'][0];
                        break;
                    case 'makerBoardAdvance_menu_mp3player_types':
                        snippet = blockInfo['fields']['mp3player_types'][0];
                        break;
                    case 'makerBoardAdvance_menu_grove_mp3player_mode':
                        snippet = blockInfo['fields']['grove_mp3player_mode'][0];
                        break;
                    case 'makerBoardAdvance_menu_speech_recognizer':
                        snippet = blockInfo['fields']['speech_recognizer'][0];
                        break;
/************************************************************************************************/
/* TinyML command*/
/************************************************************************************************/

                    case 'tinyml_updateInference':
                        // loop内でセンサーデータを更新して推論
                        // tinyml_get_class() を使う(_once版は新推論直後の1回だけ正値を返し
                        // 残りは -1 を返すため、10msループでは99%が-1にハマって誤動作する)。
                        // 通常版は次の推論(1.5秒に1回)まで同じ予測値を保持してくれる。
                        //
                        // 学習時に使ったセンサー種別に応じて読み出しコードを切り替える。
                        // tinyml_update の入力 (ax, ay, az) は:
                        //   加速度: x/y/z [g]
                        //   マイク : RMS/ZCR/Peak (0..1)
                        // と意味は違うが、特徴量計算・モデル構造は同一なので、収集側と
                        // 同じ式で 3 チャネルを並べれば既存パイプラインで推論が成立する。
                        {
                            const tinymlSensorType = (typeof window !== 'undefined'
                                && window.TinyMLShared
                                && window.TinyMLShared.dataSensorType) || 'accelerometer';
                            if (tinymlSensorType === 'microphone') {
                                snippet = `tinyml_mic_sample(&ax, &ay, &az);\ntinyml_update(ax, ay, az);\nint cls = tinyml_get_class();\n`;
                            } else {
                                snippet = `accelemeter.getAcceleration(&ax, &ay, &az);\ntinyml_update(ax, ay, az);\nint cls = tinyml_get_class();\n`;
                            }
                        }
                        break;

                    case 'tinyml_classifyOnArduino':
                        // クラス番号+1を返す（1始まりのラベル番号に変換）
                        snippet = `(cls + 1)`;
                        break;
                    case 'tinyml_isLabelOnArduino':
                        label = this.processValueInfo(blockInfo['inputs']['LABEL'], allBlocksObject);
                        // 文字列比較から整数比較に変更（ラベルは1始まり、クラスは0始まり）
                        snippet = `(cls == (${label} - 1))`;
                        break;
                    case 'tinyml_menu_labels':
                        snippet = blockInfo['fields']['labels'][0];
                        break;
                    case 'procedures_definition':
                        snippet = ''
                        break;

                    default:
                        snippet = `/* unknown block here */`;
                        console.log(snippet);
                        console.log(blockInfo);
                        alert(`使用できないブロックがふくまれています（ブロックコード：${opcode}）\nプログラムを書き込んでも，思っていた動きと違うかもしれません`);
                        break;
                }
            } catch (e) {
                console.error(e);
                alert(`プログラムの生成ができませんでした。\nブロックのつなぎ方が間違っていないか確認してください。\nエラーメッセージ：${e}\n問題が解決しない場合はhttps://kurikit.ux-xu.com/support/ からお問合せください`)
            }

            let nextBlockID = allBlocksObject[id]['next'];
            if (nextBlockID) {
                snippet += this.convertSnippet(nextBlockID, allBlocksObject);
            }
        }
        return snippet;
    }

    funcDefinition(id, allBlocksObject){
        // strict mode 対策: bare 代入されていたローカルを明示宣言
        let procProtoBlockID, proccodes, funcName, argNames, argNamesMap, funcSig;
        if (id) {
            const blockInfo = allBlocksObject[id];
            const opcode = blockInfo['opcode'];
            if (opcode == 'procedures_definition'){
                procProtoBlockID = blockInfo['inputs']['custom_block'][1];
                proccodes = allBlocksObject[procProtoBlockID]['mutation']['proccode'].split(' ');
                funcName = this.modifyFunctionName(proccodes[0]);
                let types = proccodes.filter(function( value ){
                    return value === "%s" || value === "%b";
                })
                argNames = JSON.parse(allBlocksObject[procProtoBlockID]['mutation']['argumentnames']);
                argNamesMap = argNames.map(this.modifyArgumentName.bind(this));
                for(let i = 0; i<argNamesMap.length; i++){
                    if(types[i] === "%s") argNamesMap[i] = "float " + argNamesMap[i];
                    else if(types[i] === "%b") argNamesMap[i] = "bool " + argNamesMap[i];
                }
                funcSig = 'void ' + funcName + '(' + argNamesMap + ')';
            }
            return funcSig;
        }
    }
    processValueInfo(valueInfo, allBlocksInfo) {
        if (!valueInfo) return '';
        this.blockIDs = Object.keys(allBlocksInfo)
        // console.log(`Value Info ${valueInfo}, value ${valueInfo[0]}`);
        // if(typeof valueInfo[0] === 'string') console.log("value info is not number")
        switch (valueInfo[0]) {
            case 3: // other block, or variable
                // console.log("REPORTER OR Variable")
                if (typeof valueInfo[1] === 'string') { // other block
                    const childBlockID = valueInfo[1].normalize('NFKC');
                    return this.convertSnippet(childBlockID, allBlocksInfo);
                }
            case 2:
                // console.log("Case 2")
                if (typeof valueInfo[1] === 'string') { // other block
                    const childBlockID = valueInfo[1].normalize('NFKC');
                    return this.convertSnippet(childBlockID, allBlocksInfo);
                } else { // variable
                    // --- タイマー割り込み機能(試験段階)で書き換え ---
                    // 元の処理:
                    // return this.modifyVariableName(valueInfo[1][1]);
                    const rawVarName = valueInfo[1][1];
                    const hashedVarName = this.modifyVariableName(rawVarName);
                    // タイマー割り込みと共有される変数はメイン側でアトミック読み出し
                    if (!this.inTimerHandler && this.timerSharedVars.has(rawVarName)) {
                        return `_readAtomic(&${hashedVarName})`;
                    }
                    return hashedVarName;
                }
            case 1: // literal
            // console.log("Case 1")
            for(var id of this.blockIDs){
                    if(valueInfo[1] === id){
                        const childBlockID = valueInfo[1];
                        return this.convertSnippet(childBlockID, allBlocksInfo);
                    }
                }
                return `${this.processLiteral(valueInfo[1][1].normalize('NFKC'))}`;
            default:
                // console.log("Case 0")
                if(typeof valueInfo[0] === 'string'){
                    return valueInfo[0].normalize('NFKC');
                }else{
                    console.error(`UNKNOWN VALUE TYPE: ${valueInfo[0]}`);
                }
        }
    }
}

module.exports = Sb2CppConverter;
